module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conInner"
  }, [_c('section', {
    attrs: {
      "id": "content_wrapper"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [(!_vm.askList.length) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("暂无信息")]) : _vm._e(), _vm._v(" "), (_vm.askList.length) ? _c('table', {
    staticClass: "liststyle",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "3"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.askList), function(row) {
    return _c('tr', {
      staticClass: "hovertr"
    }, [_c('td', {
      attrs: {
        "colspan": "2",
        "align": "left"
      }
    }, [_c('div', {
      staticClass: "infotop",
      staticStyle: {
        "height": "31px",
        "border-bottom": "1px solid #dbdbdb"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "60%",
        "float": "left"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/goods',
          query: {
            goods_id: row.goods_id
          }
        },
        "title": row.name
      }
    }, [_vm._v("\n                      " + _vm._s(row.name) + "\n                    ")])], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "40%",
        "float": "left"
      }
    }, [_vm._v(_vm._s(row.dateline))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both",
        "text-align": "left",
        "padding": "20px 20px 10px"
      }
    }, [_c('h2', [_vm._v("您的咨询：")]), _vm._v(" "), _c('div', [_c('p', {
      staticStyle: {
        "word-wrap": "break-word",
        "word-break": "break-all"
      },
      domProps: {
        "innerHTML": _vm._s(row.content)
      }
    })]), _vm._v(" "), (row.reply) ? _c('h2', [_vm._v("回复：")]) : _vm._e(), _vm._v(" "), (row.reply) ? _c('div', [_c('p', {
      staticStyle: {
        "word-wrap": "break-word",
        "word-break": "break-all"
      },
      domProps: {
        "innerHTML": _vm._s(row.reply)
      }
    })]) : _vm._e()])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.askList.length) ? _c('div', {
    staticClass: "pager_border"
  }, [_c('Page', {
    ref: "pages",
    attrs: {
      "total": _vm.dataTotal,
      "show-total": "",
      "page-size": _vm.pageSize,
      "size": "small",
      "show-elevator": ""
    },
    on: {
      "on-change": _vm.changepage
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data"
  }, [_c('h2', [_vm._v("我的咨询")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip"
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('img', {
    attrs: {
      "src": "//static.kxymall.com/images/gth.jpg"
    }
  }), _vm._v(" "), _c('div', [_c('h2', [_vm._v("温馨提示")]), _vm._v(" "), _c('p', [_vm._v("1、这里将显示您的咨询信息。")]), _vm._v(" "), _c('p', [_vm._v("2、您还可以查看您的咨询信息以及管理员的回复等。")])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab"
  }, [_c('ul', [_c('li', {
    staticClass: "selected"
  }, [_c('a', [_c('span', [_vm._v("我的咨询")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("咨询商品")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("提交时间")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42191da6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/member-center/right/myAdvice.vue
// module id = 1588
// module chunks = 1